import * as React from 'react';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';

import { observer } from 'mobx-react';

import { inputLabelStyle, formControlStyle } from 'jimbo/ui/Style';

import ObjectSelector from 'jimbo/ui/ObjectSelector';
import ObjectSelectDialog from 'jimbo/ui/ObjectSelectDialog';



const ObjectSelectWidget = observer(({ id, label, instance, store, fieldName, objectSelectDialogProps, valueToLabel }) => {

    const formControlClasses = formControlStyle();
    const inputLabelClasses = inputLabelStyle();


    const onValueChange = (value) => {
        if (value) {
            instance.setValue(fieldName,value);
        } else {
            instance.setValue(fieldName, null);
        }
    }

    const field = instance.$fields.get(fieldName);
    const isTouched = field.isTouched;
    const hasErrors = field.errors;
    const value = field.value ? field.value : null;

    const showError = isTouched && hasErrors;

    const displayLabel = valueToLabel(value);

    const isClearable = field.fieldDescriptor.isNull; 
   
    console.log("isclearable ", isClearable)

    return <FormControl error={showError} fullWidth classes={formControlClasses}>
        <InputLabel shrink={false} classes={inputLabelClasses} htmlFor={id}>
            {label}
        </InputLabel>
        <ObjectSelector
            ObjectSelectDialog={ObjectSelectDialog}
            objectSelectDialogProps={objectSelectDialogProps}
            value={displayLabel}
            onValueChange={onValueChange}
            clearable={isClearable}
        />
    </FormControl>
});



export default ObjectSelectWidget;
